<template>
  <div class="favorites-button" @click="showModal">
    <BbIcon class="favorites-icon" name="heart" type="filled" />
    <div v-if="favoriteDocumentsCount" class="favorites-count">
      {{ favoriteDocumentsCount }}
    </div>
  </div>
</template>

<script>
import useModals from '~/composables/useModals';
import useCollections from '~/composables/useCollections';
import { CURRENT_DIALOG } from '~/constants/conversationModels';

export default {
  name: 'FavoritesMenu',
  components: {},

  setup() {
    const { setCurrentDocumentsDialog } = useModals();
    const { favoriteDocumentsCount } = useCollections();
    const showModal = () => {
      setCurrentDocumentsDialog(CURRENT_DIALOG.favorites_panel);
    };

    return {
      favoriteDocumentsCount,
      showModal,
    };
  },
};
</script>

<style scoped lang="scss">
.favorites-button {
  position: relative;
  padding: $bb-spacing-2;
  border-radius: 8px;
  cursor: pointer;
  line-height: 1;

  &:hover,
  &.active {
    background: $bb-interface-8;
  }

  .favorites-icon {
    color: $bb-neutral-1;
  }

  .favorites-count {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 3px;
    left: 21px;
    width: 17px;
    height: 17px;
    background: $bb-interface-5;
    border: 1px solid $bb-neutral-0;
    border-radius: 100px;
  }
}
</style>
